import { GridValueFormatterParams } from '@mui/x-data-grid-pro';

import { Option } from '../../../ControlledFields/ControlledSelect';

export const singleSelectValueFormatter = (
  params: GridValueFormatterParams,
  options: Option[]
) => {
  const { value: fieldValue } = params;
  const option = options?.find((options) => options.value === fieldValue);
  return option?.label;
};
